import { State } from '../state';

export const GetSubscriptionSelectors = {
    // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
    getSubscription: (state: State) => state.GetSubscription,
    // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
    createEntitlement: (state: State) => state.GetSubscription,
    // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
    GetPartNumber: (state: State) => state.GetSubscription,
    // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
    mappingSiteIdActivationId: (state: State) => state.GetSubscription,
};